var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredentialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5783",
    "data-name": "Group 5783",
    transform: "translate(-25 -25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5635",
    "data-name": "Group 5635",
    transform: "translate(-802 -452)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_862",
    "data-name": "Ellipse 862",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(827 477)",
    fill: "#e8f0fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5737",
    "data-name": "Group 5737",
    transform: "translate(38.023 37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29057",
    "data-name": "Path 29057",
    d: "M14.491,15.5H14.5m-5,0h.009",
    fill: "none",
    stroke: "#486eb1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29058",
    "data-name": "Path 29058",
    d: "M4.268,18.845A3.519,3.519,0,0,0,7.56,21.9c1.417.065,2.856.1,4.44.1s3.024-.034,4.44-.1a3.519,3.519,0,0,0,3.292-3.056A25.024,25.024,0,0,0,20,15.5a25.024,25.024,0,0,0-.268-3.345A3.519,3.519,0,0,0,16.44,9.1C15.024,9.034,13.585,9,12,9s-3.024.034-4.44.1a3.519,3.519,0,0,0-3.292,3.056A25.031,25.031,0,0,0,4,15.5,25.031,25.031,0,0,0,4.268,18.845Z",
    fill: "none",
    stroke: "#486eb1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29059",
    "data-name": "Path 29059",
    d: "M7.5,9V6.5a4.5,4.5,0,0,1,9,0V9",
    fill: "none",
    stroke: "#486eb1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialsIcon);
export default __webpack_public_path__ + "static/media/credentialsIcon.56eae7f568fa50b37a852f2f08ac6095.svg";
export { ForwardRef as ReactComponent };